/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ReportType = 'Unknown' | 'Bill' | 'ClinicalExaminationReport' | 'ResultsOfCytologicalExaminationOfTheSkinImpression' | 'ResultsOfQualitativeUrineAndSedimentExamination' | 'TestResults' | 'SterilizationCertificate' | 'ResultsOfCytologicalExaminationOfEarSwab' | 'ResultsOfCytologicalExaminationOfSkinSwab' | 'ResultsOfCytologicalExaminationOfCellophaneTapeSkinSwab' | 'ClinicalObservationOfDogForRabies' | 'OwnersConsentForSurgical' | 'TestResult4D' | 'ResultsOfCHWTesting' | 'HeartwormDisease' | 'FnaFinding' | 'ReferralForHistopathology' | 'RequestForExamination' | 'VetLabAnamnesisRequest' | 'AntibiogramCertificate' | 'LabBiochemDog' | 'LabBiochemCat' | 'LabHematoBioDog' | 'LabHematoDog' | 'LabHematoCat' | 'LabHematoBioCat' | 'ClinicalExamination' | 'DischargeEpicrisis' | 'CertificateOriginHealth' | 'RabiesExaminationCertificate' | 'BlankCertificate' | 'BandagesMaintenance' | 'DurogesicPatchInstructions' | 'ChemotherapyProtocol' | 'AnamnesticCard' | 'OwnerStatementVaccination' | 'OwnerStatementNewPassport' | 'OwnerStatementDeregistration' | 'OwnerStatementDebtInstallments' | 'OwnerStatementTreatmentProcedure' | 'OwnerStatementDentalTreatment' | 'OwnerStatementInpatientAdmission' | 'PrijemniFormular' | 'OwnerStatementOwnershipChange' | 'OwnerStatementEuthanasia' | 'ResultTrioDog' | 'ResultTrioCat' | 'CpvCcvFinding' | 'UltrasoundFinding' | 'UrineFinding' | 'SpermogramFinding' | 'RtgFinding' | 'RadiologyFinding' | 'OrthopedicFinding' | 'MriFinding' | 'LeishmaniaFinding' | 'CdvFinding' | 'BaepFinding' | 'BabesiaFinding' | 'AnalysisPointsFinding' | 'Nalaz4dL' | 'KoproloskiFinding' | 'OphthalmologyReport' | 'FipTest' | 'FivTest' | 'PreoperativePreparation' | 'PostoperativeCare' | 'PostCesareanCare' | 'TravelInstructions' | 'EcollarInstructions' | 'ContractVeterinaryServices' | 'LiverExamination' | 'RabiesVaccinationCertificate' | 'HealthRecord' | 'PremiumInvoice';

export const ReportType = {
    Unknown: 'Unknown' as ReportType,
    Bill: 'Bill' as ReportType,
    ClinicalExaminationReport: 'ClinicalExaminationReport' as ReportType,
    ResultsOfCytologicalExaminationOfTheSkinImpression: 'ResultsOfCytologicalExaminationOfTheSkinImpression' as ReportType,
    ResultsOfQualitativeUrineAndSedimentExamination: 'ResultsOfQualitativeUrineAndSedimentExamination' as ReportType,
    TestResults: 'TestResults' as ReportType,
    SterilizationCertificate: 'SterilizationCertificate' as ReportType,
    ResultsOfCytologicalExaminationOfEarSwab: 'ResultsOfCytologicalExaminationOfEarSwab' as ReportType,
    ResultsOfCytologicalExaminationOfSkinSwab: 'ResultsOfCytologicalExaminationOfSkinSwab' as ReportType,
    ResultsOfCytologicalExaminationOfCellophaneTapeSkinSwab: 'ResultsOfCytologicalExaminationOfCellophaneTapeSkinSwab' as ReportType,
    ClinicalObservationOfDogForRabies: 'ClinicalObservationOfDogForRabies' as ReportType,
    OwnersConsentForSurgical: 'OwnersConsentForSurgical' as ReportType,
    TestResult4D: 'TestResult4D' as ReportType,
    ResultsOfCHWTesting: 'ResultsOfCHWTesting' as ReportType,
    HeartwormDisease: 'HeartwormDisease' as ReportType,
    FnaFinding: 'FnaFinding' as ReportType,
    ReferralForHistopathology: 'ReferralForHistopathology' as ReportType,
    RequestForExamination: 'RequestForExamination' as ReportType,
    VetLabAnamnesisRequest: 'VetLabAnamnesisRequest' as ReportType,
    AntibiogramCertificate: 'AntibiogramCertificate' as ReportType,
    LabBiochemDog: 'LabBiochemDog' as ReportType,
    LabBiochemCat: 'LabBiochemCat' as ReportType,
    LabHematoBioDog: 'LabHematoBioDog' as ReportType,
    LabHematoDog: 'LabHematoDog' as ReportType,
    LabHematoCat: 'LabHematoCat' as ReportType,
    LabHematoBioCat: 'LabHematoBioCat' as ReportType,
    ClinicalExamination: 'ClinicalExamination' as ReportType,
    DischargeEpicrisis: 'DischargeEpicrisis' as ReportType,
    CertificateOriginHealth: 'CertificateOriginHealth' as ReportType,
    RabiesExaminationCertificate: 'RabiesExaminationCertificate' as ReportType,
    BlankCertificate: 'BlankCertificate' as ReportType,
    BandagesMaintenance: 'BandagesMaintenance' as ReportType,
    DurogesicPatchInstructions: 'DurogesicPatchInstructions' as ReportType,
    ChemotherapyProtocol: 'ChemotherapyProtocol' as ReportType,
    AnamnesticCard: 'AnamnesticCard' as ReportType,
    OwnerStatementVaccination: 'OwnerStatementVaccination' as ReportType,
    OwnerStatementNewPassport: 'OwnerStatementNewPassport' as ReportType,
    OwnerStatementDeregistration: 'OwnerStatementDeregistration' as ReportType,
    OwnerStatementDebtInstallments: 'OwnerStatementDebtInstallments' as ReportType,
    OwnerStatementTreatmentProcedure: 'OwnerStatementTreatmentProcedure' as ReportType,
    OwnerStatementDentalTreatment: 'OwnerStatementDentalTreatment' as ReportType,
    OwnerStatementInpatientAdmission: 'OwnerStatementInpatientAdmission' as ReportType,
    PrijemniFormular: 'PrijemniFormular' as ReportType,
    OwnerStatementOwnershipChange: 'OwnerStatementOwnershipChange' as ReportType,
    OwnerStatementEuthanasia: 'OwnerStatementEuthanasia' as ReportType,
    ResultTrioDog: 'ResultTrioDog' as ReportType,
    ResultTrioCat: 'ResultTrioCat' as ReportType,
    CpvCcvFinding: 'CpvCcvFinding' as ReportType,
    UltrasoundFinding: 'UltrasoundFinding' as ReportType,
    UrineFinding: 'UrineFinding' as ReportType,
    SpermogramFinding: 'SpermogramFinding' as ReportType,
    RtgFinding: 'RtgFinding' as ReportType,
    RadiologyFinding: 'RadiologyFinding' as ReportType,
    OrthopedicFinding: 'OrthopedicFinding' as ReportType,
    MriFinding: 'MriFinding' as ReportType,
    LeishmaniaFinding: 'LeishmaniaFinding' as ReportType,
    CdvFinding: 'CdvFinding' as ReportType,
    BaepFinding: 'BaepFinding' as ReportType,
    BabesiaFinding: 'BabesiaFinding' as ReportType,
    AnalysisPointsFinding: 'AnalysisPointsFinding' as ReportType,
    Nalaz4dL: 'Nalaz4dL' as ReportType,
    KoproloskiFinding: 'KoproloskiFinding' as ReportType,
    OphthalmologyReport: 'OphthalmologyReport' as ReportType,
    FipTest: 'FipTest' as ReportType,
    FivTest: 'FivTest' as ReportType,
    PreoperativePreparation: 'PreoperativePreparation' as ReportType,
    PostoperativeCare: 'PostoperativeCare' as ReportType,
    PostCesareanCare: 'PostCesareanCare' as ReportType,
    TravelInstructions: 'TravelInstructions' as ReportType,
    EcollarInstructions: 'EcollarInstructions' as ReportType,
    ContractVeterinaryServices: 'ContractVeterinaryServices' as ReportType,
    LiverExamination: 'LiverExamination' as ReportType,
    RabiesVaccinationCertificate: 'RabiesVaccinationCertificate' as ReportType,
    HealthRecord: 'HealthRecord' as ReportType,
    PremiumInvoice: 'PremiumInvoice' as ReportType
};